import { createContext } from "react";

interface IStepper {
    stepLength: number;
    onClick: (name: string, index: number) => void;
}

const StepperContext = createContext<IStepper>({ stepLength: 0, onClick: () => undefined });

export default StepperContext;
